import { Component, inject, computed, signal, ViewChild, ElementRef } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { DocumentTypeService } from '../../../core/services/document-type.service';
import { TenantConfigService } from '../../../core/config/tenant-config';
import { StateService } from '../../../core/services/state.service';
import { OrderProcessingService } from '../../../core/services/order-processing';

import { AuthService } from '../../../core/services/auth.service';
import { Login } from '../login/login';

@Component({
    selector: 'app-header',
    imports: [RouterLink, Login],
    templateUrl: './header.html',
    styleUrl: './header.scss',
})
export class Header {
    public authService = inject(AuthService);
    public documentTypeService = inject(DocumentTypeService);
    public tenantConfigService = inject(TenantConfigService);
    public stateService = inject(StateService);
    public orderProcessing = inject(OrderProcessingService);
    public router = inject(Router);

    public pageTitle = this.stateService.dynamicTitle;
    
    public countryName = computed(() => {
        const url = this.router.url;
        const segments = url.split('?')[0].split('/').filter(Boolean);
        
        if (segments.length > 0) {
            let first = segments[0].toLowerCase();
            return first.split('-')[0];
        }
        return '';
    });

    public hasState = computed(() => {
        const code = this.stateService.stateCode();
        return !!code && code !== '' && code !== 'select';
    });

    public stateCode = this.stateService.stateCode;

    public isMenuCollapsed = signal<boolean>(true);

    toggleMenu() {
        this.isMenuCollapsed.update(v => !v);
    }

    closeMenu() {
        this.isMenuCollapsed.set(true);
    }

    public isAudioPlaying = signal<boolean>(false);
    @ViewChild('anthemAudio') anthemAudio!: ElementRef<HTMLAudioElement>;

    toggleAudio() {
        if (!this.anthemAudio?.nativeElement) return;
        
        if (this.isAudioPlaying()) {
            this.anthemAudio.nativeElement.pause();
            this.isAudioPlaying.set(false);
        } else {
            this.anthemAudio.nativeElement.play();
            this.isAudioPlaying.set(true);
        }
    }

    constructor() {}
}
